import bbblogo from "./bbblogo.png";
import lllogo from "./lllogo.png";
import project1 from "./Nelutai.jpg";
import project2 from "./SDAI.png";
import project3 from "./sea.png";
import project4 from "./tesla.jpeg";
import project5 from "./RTI.jpeg";
import project6 from "./vidua.png";
import project7 from "./passport.jpg";
import project8 from "./near.png";
import project9 from "./otethbg.jpg";
import project10 from "./stdesci.png";
import partner1 from "./LedgerLeopard.png";
import partner2 from "./StayDirect.png";
import partner3 from "./UNDP.png";
import partner4 from "./ReSPA.png";
import partner5 from "./stblkn.jpeg";
import partner6 from "./nenadsky.webp";
import partner7 from "./smartconnpn.png";
import partner8 from "./primelab.png";
import partner9 from "./NBG.png";
import partner10 from "./zen_logo.png";
import partner11 from "./kyramarios.png";
import partner12 from "./StayRafa.png";

export const images = {
  bbblogo,
  lllogo,
  project1,
  project2,
  project3,
  project4,
  project5,
  project6,
  project7,
  project8,
  project9,
  project10,
  partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  partner6,
  partner7,
  partner8,
  partner9,
  partner10,
  partner11,
  partner12
};